import { ETTypeInfos } from "@cervval.js/common-dto/src/dtoModel.service";
import { keys, typeInfos } from "@cervval.js/ts-reflect";
import { AttachmentDTO } from "./attachment.dto";

export type AttachmentElementTypes = {
    "attachments": AttachmentDTO
}

export type AttachmentElementTypeNames = keyof AttachmentElementTypes;
export const attachmentElementTypeNames: AttachmentElementTypeNames[] = keys<AttachmentElementTypes>();

export const attachmentTypeInfos: ETTypeInfos<AttachmentElementTypes> = {
    "attachments": {
        keys: keys<AttachmentDTO>(),
        typeInfos: typeInfos<AttachmentDTO>()
    }
};